function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

const details = document.querySelectorAll(
  '[id^="ProductInfo-template--"] details'
)

function accordianDisable(event) {
  for (i = 0; i < details.length; i++) {
    if (details[i] != event) {
      details[i].removeAttribute('open')
    }
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    accordianDisable(event.currentTarget.closest('details'))
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    )
  })

  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const isTouchEnabled = () => {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true
  )
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.changeEvent = new Event('change', { bubbles: true })
  }

  init() {
    this.input = this.querySelector('input')
    this.ATCButton = document.querySelector(
      '.product-form button[type="submit"]'
    )
    this.errorElement = document.querySelector(`[data-product-form-error]`)
    this.errorMessage = document.querySelector(
      `[data-product-form-error-message]`
    )
    if (this.input && this.input.hasAttribute('max')) {
      this.maxQuantity = parseInt(this.input.getAttribute('max'), 10)
    }
  }

  onKeyDownEvent(event) {
    const currentQuantity = parseInt(this.input.value, 10)
    if (event.key === 'Enter') {
      if (currentQuantity > this.maxQuantity) {
        event.preventDefault()
      }
      this.input.blur()
    }
  }

  onInputChange(event) {
    const currentQuantity = parseInt(this.input.value, 10)
    const hideErrorMessage = () => {
      this.errorElement.classList.add('aria-hidden:hidden')
    }
    if (!this.maxQuantity) return
    if (currentQuantity === this.maxQuantity) {
      this.errorMessage.innerText = `You have reached the maximum allowed quantity of ${this.maxQuantity}.`
      this.errorElement.classList.remove('aria-hidden:hidden')
      this.ATCButton.removeAttribute('disabled')
      setTimeout(hideErrorMessage, 6000)
    }
    if (currentQuantity > this.maxQuantity) {
      this.errorMessage.innerText = `The quantity exceeds the maximum allowed quantity of ${this.maxQuantity}.`
      hideErrorMessage()
      this.ATCButton.setAttribute('disabled', 'true')
    } else if (currentQuantity < this.maxQuantity) {
      this.errorElement.classList.add('aria-hidden:hidden')
      this.ATCButton.removeAttribute('disabled')
    }
  }

  connectedCallback() {
    this.init()
    if (this.input && !this.input.hasAttribute('data-mattress-fee-qty')) {
      this.input.addEventListener('change', this.onInputChange.bind(this))
      this.input.addEventListener('keydown', this.onKeyDownEvent.bind(this))
    }

    this.querySelectorAll('button').forEach((button) => {
      // Prevent double initialization
      if (button.hasAttribute('data-quantity-initialized')) return
      button.setAttribute('data-quantity-initialized', 'true')

      button.setAttribute('disabled', 'true')
      button.addEventListener('click', this.onButtonClick.bind(this))
      setTimeout(() => {
        if (!button.dataset.minusMattressFee) {
          button.removeAttribute('disabled')
        }
      }, 1000)
    })
  }

  disconnectedCallback() {
    if (this.input && !this.input.hasAttribute('data-mattress-fee-qty')) {
      this.input.removeEventListener('change', this.onInputChange.bind(this))
      this.input.removeEventListener('keydown', this.onKeyDownEvent.bind(this))
    }

    this.querySelectorAll('button').forEach((button) => {
      button.removeEventListener('click', this.onButtonClick.bind(this))
    })
  }

  onButtonClick(event) {
    const previousValue = this.input.value
    event.preventDefault()

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
    }
  }
}

customElements.define('quantity-input', QuantityInput)

class QuantityInputRecurate extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) => {
      // Prevent double initialization
      if (button.hasAttribute('data-quantity-initialized')) return
      button.setAttribute('data-quantity-initialized', 'true')

      button.addEventListener('click', this.onButtonClick.bind(this))
    })
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input-recurate', QuantityInputRecurate)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    const preOrderVariant = document.querySelector(
      `#product-form-${this.dataset.section}`
    ).dataset.preOrder
    let preOrderAvailable = false
    if (preOrderVariant === 'true') {
      preOrderAvailable = true
    }
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false, preOrderAvailable)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateVariantStatuses()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true, preOrderAvailable)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const SliderGallery = document.querySelector(
      `[id="Slider-Gallery-${this.dataset.section}"]`
    )
    const MediaToScroll = SliderGallery.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (MediaToScroll) {
      const left = MediaToScroll.offsetLeft
      SliderGallery.scrollTo({ top: 0, left: left, behavior: 'smooth' })
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    )
    const inputWrappers = [...this.querySelectorAll('.product-form__input')]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ]
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value')
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value')
        )
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('.product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        )
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const locationModalSource = html.getElementById(`location-modal`)
        const locationModalDestination =
          document.getElementById(`location-modal`)

        const giftWrapSource = document.getElementById(`GiftWrap-${sectionId}`)
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        )
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        )
        const formSource = html.getElementById(
          `product-form-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const formDestination = document.getElementById(
          `product-form-${this.dataset.section}`
        )

        if (formSource && formDestination) {
          if (formSource && formDestination && !locationModalSource) {
            formDestination.innerHTML = formSource.innerHTML
            formDestination.innerHTML = formSource.innerHTML
          } else if (locationModalSource) {
            const atcBtnSource = formSource.querySelector(
              '.button[type="submit"]'
            )
            const atcBtnDestination = formDestination.querySelector(
              '.button[type="submit"]'
            )
            const productIDSource = formSource.querySelector('input[name="id"]')
            const productIDDestination =
              formDestination.querySelector('input[name="id"]')

            if (atcBtnSource && atcBtnDestination) {
              atcBtnDestination.innerHTML = atcBtnSource.innerHTML
            }
            if (productIDSource && productIDDestination) {
              productIDDestination.value = productIDSource.value
            }
          }
        }
        const productRecommendationsSource = html.getElementById(
          `productRecommendations`
        )
        const productRecommendationsDestination = document.getElementById(
          `productRecommendations`
        )

        if (productRecommendationsSource && productRecommendationsDestination) {
          productRecommendationsDestination.innerHTML =
            productRecommendationsSource.innerHTML
        }

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden')
          )
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === ''
          )
        let preOrderAvailable = false
        if (formSource.dataset.preOrder === 'true') {
          preOrderAvailable = true
        }
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
          false,
          preOrderAvailable
        )

        /**
         * Gift wrap.
         */
        if (giftWrapSource) {
          document.getElementById(`GiftWrap-${sectionId}`).innerHTML =
            html.getElementById(`GiftWrap-${sectionId}`).innerHTML
        }

        // Re-setup size chart listeners after content update
        setupSizeChartListeners()
      })
  }
  toggleAddButton(disable = true, text, modifyClass = true, preOrder = false) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const preOrderAvailable = preOrder
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return
    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    )
    const sku = document.getElementById(`Sku-${this.dataset.section}`)

    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
    if (inventory) inventory.classList.add('visibility-hidden')
    if (sku) sku.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.removeAttribute('aria-disabled')
      } else {
        input.setAttribute('aria-disabled', 'true')
      }
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)

class VariantSelectsRecurate extends HTMLElement {
  constructor() {
    super()
    this.currentVariant = null
    const jsonElement = this.querySelector('[type="application/json"]')
    if (jsonElement) {
      try {
        this.variantData = JSON.parse(jsonElement.textContent)
      } catch (error) {
        console.error('Failed to parse variant data:', error)
        this.variantData = []
      }
    } else {
      console.warn('No JSON element found for variant data.')
      this.variantData = []
    }
    this.lastExecutionTime = null

    // Listen for change events
    this.addEventListener('change', this.onVariantChange.bind(this))
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(false, window.variantStrings.addToCart, false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateVariantStatuses()

    if (!this.currentVariant) {
      this.toggleAddButton(true, 'load', true)
      this.renderProductInfo()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId() {
    const variantData = this.getVariantData()
      ? this.getVariantData()
      : this.variantData
    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const SliderGallery = document.querySelector(
      `[id="Slider-Gallery-${this.dataset.section}"]`
    )
    const MediaToScroll = SliderGallery.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (MediaToScroll) {
      const left = MediaToScroll.offsetLeft
      SliderGallery.scrollTo({ top: 0, left: left, behavior: 'smooth' })
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    )
    const inputWrappers = [...this.querySelectorAll('.product-form__input')]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ]
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value')
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value')
        )
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('.product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    const setUnavailable = () => {
      const button = document.getElementById(
        `product-form-${this.dataset.section}`
      )
      const addButton = button.querySelector('[name="add"]')
      const addButtonText = button.querySelector('[name="add"] > span')
      const price = document.getElementById(`price-${this.dataset.section}`)
      const inventory = document.getElementById(
        `Inventory-${this.dataset.section}`
      )
      const sku = document.getElementById(`Sku-${this.dataset.section}`)

      if (!addButton) return
      addButtonText.textContent = window.variantStrings.unavailable
      if (price) price.classList.add('visibility-hidden')
      if (inventory) inventory.classList.add('visibility-hidden')
      if (sku) sku.classList.add('visibility-hidden')
    }

    if (!this.currentVariant) {
      this.setUnavailable()
      return
    }
    const requestedVariantId = this.currentVariant.id

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        )
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        )
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        )
        const formSource = html.getElementById(
          `product-form-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const formDestination = document.getElementById(
          `product-form-${this.dataset.section}`
        )
        if (formSource && formDestination) {
          formDestination.innerHTML = formSource.innerHTML
        }
        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden')
          )
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === ''
          )

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )

        // Re-setup size chart listeners after content update
        setupSizeChartListeners()
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text === 'load') {
        const svgMarkup = `
<svg aria-hidden="true" class="w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" style="fill: grey;"></path>
  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" style="fill: white;"></path>
</svg>`
        addButtonText.innerHTML = svgMarkup
      } else if (text) {
        addButtonText.textContent = text
      }
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    )
    const sku = document.getElementById(`Sku-${this.dataset.section}`)

    if (!addButton) return
    const executeIfRecent = () => {
      const now = Date.now()

      // Check if the code has run within the last 1.5 seconds
      if (this.lastExecutionTime && now - this.lastExecutionTime <= 1000) {
        if (!this.currentVariant) {
          if (addButtonText) {
            addButtonText.textContent = window.variantStrings.unavailable
          }
        }
      }

      // Update the last execution timestamp
      this.lastExecutionTime = now
    }

    // Simulate calling the function
    setInterval(() => {
      executeIfRecent()
    }, 1000)

    if (price) price.classList.add('visibility-hidden')
    if (inventory) inventory.classList.add('visibility-hidden')
    if (sku) sku.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects-recurate', VariantSelectsRecurate)

class VariantRadiosRecurate extends VariantSelectsRecurate {
  constructor() {
    super()
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.removeAttribute('aria-disabled')
      } else {
        input.setAttribute('aria-disabled', 'true')
      }
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    })
  }
}

customElements.define('variant-radios-recurate', VariantRadiosRecurate)

// Define variables
const toggles = document.querySelectorAll('.toggle')
// Set toggle actions
function toggleAccord(e) {
  e.preventDefault()
  // Deactivate all toggles
  if (this.parentNode.classList.contains('active')) {
    this.parentNode.classList.remove('active')
  } else {
    for (i = 0; i < toggles.length; i++) {
      toggles[i].parentNode.classList.remove('active')
    }
    this.parentNode.classList.add('active')
  }
}
// Apply event listeners
for (i = 0; i < toggles.length; i++) {
  toggles[i].addEventListener('click', toggleAccord)
}
// Size Chart - Function to set up event listeners
function setupSizeChartListeners() {
  const showButton = document.getElementById('showDialog')
  const sizeChart = document.getElementById('sizeChart')
  const close = document.getElementById('close')

  // "Show the dialog" button opens the <dialog> modally
  if (showButton && !showButton.hasAttribute('data-listener-added')) {
    showButton.addEventListener('click', () => {
      sizeChart.showModal()
      window.scrollTo({
        top: 0,
        behavior: 'auto', // or 'smooth' for smooth scrolling
      })
    })
    showButton.setAttribute('data-listener-added', 'true')
  }

  if (close && !close.hasAttribute('data-listener-added')) {
    close.addEventListener('click', () => {
      sizeChart.close()
    })
    close.setAttribute('data-listener-added', 'true')
  }
}

// Initialize size chart listeners on page load
setupSizeChartListeners()

document.addEventListener('product:reload', () => {
  setupSizeChartListeners()
})

// Condition Chart
const conditionChart = document.getElementById('conditionChart')
const infoButton = document.getElementById('infoButton')
const closeChart = document.getElementById('closeChart')
const dialogBox = document.querySelector('.dialogBox')

if (infoButton) {
  infoButton.addEventListener('click', () => {
    conditionChart.showModal()
    window.scrollTo({
      top: 0,
      behavior: 'auto', // or 'smooth' for smooth scrolling
    })
    conditionChart.setAttribute('open', true)
  })
}

if (closeChart) {
  closeChart.addEventListener('click', () => {
    conditionChart.close()
  })
}

document.body.addEventListener('click', (event) => {
  if (conditionChart != null && conditionChart.open) {
    if (
      !dialogBox.contains(event.target) &&
      !infoButton.contains(event.target)
    ) {
      conditionChart.close()
    }
  }
})

/**
 * Gift wrap.
 */
customElements.define(
  'gift-wrap',
  class GiftWrap extends HTMLElement {
    constructor() {
      super()

      this.setNodeSelectors()
      this.setEventListeners()
    }

    /**
     * Sets the element query selectors.
     */
    setNodeSelectors() {
      this.nodeSelectors = {
        button: this.querySelector('[js-gift-wrap="button"]'),
        cartItems: document.querySelector('cart-items'),
        cartDrawerItems: document.querySelector('cart-drawer-items'),
        cartDrawer: document.querySelector('cart-drawer'),
        error: this.querySelector('[js-gift-wrap="error"]'),
      }
    }

    /**
     * Sets the event listeners.
     */
    setEventListeners() {
      if (this.nodeSelectors.button) {
        this.nodeSelectors.button.addEventListener('click', (event) =>
          this.handleSubmit(event)
        )
      }
    }

    /**
     * Returns a list of sections to render on cart change.
     * @returns {Array}
     */
    getSectionsToRender() {
      const sections = []

      /**
       * Cart page.
       */
      if (this.nodeSelectors.cartItems) {
        this.nodeSelectors.cartItems
          .getSectionsToRender()
          .forEach((section) => {
            if (!sections.find((item) => item.section === section.section)) {
              sections.push(section)
            }
          })
      }

      /**
       * Cart drawer.
       */
      if (this.nodeSelectors.cartDrawerItems) {
        this.nodeSelectors.cartDrawerItems
          .getSectionsToRender()
          .forEach((section) => {
            if (!sections.find((item) => item.section === section.section)) {
              sections.push(section)
            }
          })
      }

      return sections
    }

    /**
     * Returns the fetch configuration based on the form event.
     * @returns {Object}
     */
    getFetchConfig() {
      const form = new FormData()
      const config = fetchConfig('javascript')
      const sections = this.getSectionsToRender()

      form.append(
        'sections',
        sections.map((section) => section.section)
      )
      form.append('sections_url', window.location.pathname)
      form.append('id', Number(this.dataset.variant))

      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      config.body = form

      delete config.headers['Content-Type']

      return config
    }

    /**
     * Resets the submit button.
     */
    resetButton() {
      if (this.nodeSelectors.button) {
        this.nodeSelectors.button.disabled = false
        this.nodeSelectors.button.innerHTML =
          this.nodeSelectors.button.dataset.label
      }
    }

    /**
     * Sets the error state.
     */
    setErrorState() {
      this.resetButton()
      this.nodeSelectors.error.classList.remove('hidden')
    }

    /**
     * Handles the submit event.
     */
    handleSubmit(event) {
      event.preventDefault()

      if (this.nodeSelectors.button) {
        this.nodeSelectors.button.disabled = true
        this.nodeSelectors.button.innerHTML =
          this.nodeSelectors.button.dataset.labelAdding
      }

      try {
        fetch(routes.cart_add_url, this.getFetchConfig())
          .then((response) => response.json())
          .then((response) => {
            if (response.status === 404) {
              this.setErrorState()
              return
            }

            this.resetButton()
            this.renderContents(response)
          })
      } catch {
        this.setErrorState()
      }
    }

    /**
     * Renders the returned cart contents.
     * @param {Object} response - The cart add response.
     */
    renderContents(response) {
      if (this.nodeSelectors.cartDrawer) {
        this.nodeSelectors.cartDrawer.renderContents(response)
      }

      if (this.nodeSelectors.cartItems) {
        this.nodeSelectors.cartItems.renderContents(response)
      }
    }
  }
)
